module.exports = __webpack_public_path__ + "img/why3.10f5f2e6.jpg";